const BACK_REFERENCES = new Set(['as above', 'as above.', 'same as above', 'same as above.']);

const NULLISH = new Set(['na', 'n/a', 'n.a.', 'nil', 'none', 'null', 'not available', 'not applicable', 'unknown']);

const PUNCTUATION_ONLY = /^[^\p{L}\p{N}]+$/u;

export const normaliseText = (value?: string | null): string => value?.replace(/\s+/g, ' ').trim() ?? '';

export const isBackReference = (value?: string | null): boolean => BACK_REFERENCES.has(normaliseText(value).toLowerCase());

export const isPlaceholderValue = (value?: string | null): boolean => {
    const text = normaliseText(value);
    if (!text) return true;
    const normalised = text.toLowerCase();
    return BACK_REFERENCES.has(normalised) || NULLISH.has(normalised) || PUNCTUATION_ONLY.test(text);
};

export const withoutPlaceholders = (values?: (string | undefined)[] | null): string[] =>
    (values ?? []).map(normaliseText).filter((value) => !isPlaceholderValue(value));
